export const pushStart = <T>(currentState: T[], newValue: T) => [newValue, ...currentState];
export const pushEnd = <T>(currentState: T[], newValue: T) => [...currentState, newValue];
export const removeByIndex = <T>(currentState: T[], indexToRemove: number) => currentState.filter((_value, index) => index !== indexToRemove);
export const setByIndex = <T>(currentState: T[], newValue: T, indexToEdit: number) => currentState.map((value, index) => (index === indexToEdit ? newValue : value));

/** [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] */
export const array1to10: readonly number[] = Array.from({length: 10}).map((_value, index) => index+1);

const _array10of0s: readonly number[] = Array(10).fill(0); // 10 elements each containing 0
/** Creates a copy of the array [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] */
export const array10of0s = () => [..._array10of0s];

export const otherArray = [
    'other1', 'other2',
    'other3', 'other4',
    'other5', 'other6',
    'other7', 'other8',
    'other9', 'other10'
] as const;

export const otherFeeArray = [ // for ship operator invoice
    'otherFee1', 'otherFee2',
    'otherFee3', 'otherFee4',
    'otherFee5', 'otherFee6',
    'otherFee7', 'otherFee8',
    'otherFee9', 'otherFee10'
] as const;

export const otherCostArray = [ // for inspecting company invoice
    'otherCost1', 'otherCost2',
    'otherCost3', 'otherCost4',
    'otherCost5', 'otherCost6',
    'otherCost7', 'otherCost8',
    'otherCost9', 'otherCost10'
] as const;

export const otherEvidenceFileIdArray = [
    'otherEvidence1Id', 'otherEvidence2Id',
    'otherEvidence3Id', 'otherEvidence4Id',
    'otherEvidence5Id', 'otherEvidence6Id',
    'otherEvidence7Id', 'otherEvidence8Id',
    'otherEvidence9Id', 'otherEvidence10Id'
] as const;
